/*
 * Copyright (c) 2019. Willker Gomes
 */
export default class Address {

  constructor(props) {
    const {
      id,
      estado,
      cidade,
      cep,
      bairro,
      complemento,
      endereco,
      pontoReferencia,
      createdAt,
      updatedAt,
    } = props;

    this.id = id;
    this.estado = estado || '';
    this.cidade = cidade || '';
    this.cep = cep || '';
    this.bairro = bairro || '';
    this.complemento = complemento || '';
    this.endereco = endereco || '';
    this.pontoReferencia = pontoReferencia || '';
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
  }

  /*
      endereco:
      bairro: "Aldeota"
      cep: "60000000"
      cidade: "Fortaleza"
      complemento: "BL 84 apto 754"
      createdAt: "2019-08-19T19:37:14.574Z"
      endereco: "Avenida X"
      estado: "CEARÁ"
      id: 1
      pontoReferencia: "Aqui"
      updatedAt: "2019-08-19T19:37:14.574Z"
  * */

}
